import { ProjectPhase } from './../../model/general/ProjectPhase';
import { Technology } from '../general/Technology';
import { ProjectStage } from '../general/ProjectStage';

export class LessonLearntFilter {
  applicableTo: String;
  authorUserId: String;
  categoryIds: String[];
  countryCodes: String[];
  discussedInTeam: String[];
  identifierUserId: String;
  lessonsLearnedBestPractice: String[];
  projectPhase: ProjectPhase[];
  projectStage: ProjectStage[];
  status: String[];
  technologies: Technology[];
  projectId: String;
}
